import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

type ChartColor = 'chart-1' | 'chart-2' | 'chart-4' | 'chart-5';

const COLOR_CLASSES: Record<ChartColor, { iconBg: string; title: string }> = {
	'chart-1': { iconBg: 'bg-chart-1/15', title: 'text-chart-1' },
	'chart-2': { iconBg: 'bg-chart-2/15', title: 'text-chart-2' },
	'chart-4': { iconBg: 'bg-chart-4/15', title: 'text-chart-4' },
	'chart-5': { iconBg: 'bg-chart-5/15', title: 'text-chart-5' },
};

interface LandingsPageCardProps {
	icon: LucideIcon;
	title: string;
	description: string;
	color: ChartColor;
	action?: ReactNode;
	children: ReactNode;
	className?: string;
}

export default function LandingsPageCard({
	icon: Icon,
	title,
	description,
	color,
	action,
	children,
	className,
}: LandingsPageCardProps) {
	const colors = COLOR_CLASSES[color];

	return (
		<Card className={cn('gap-0 py-0 shadow-sm overflow-hidden', className)}>
			<CardHeader className='border-b px-4 py-4 flex flex-col gap-3'>
				<div className='flex w-full items-center gap-3 min-w-0'>
					<div className={cn('rounded-lg p-2 shrink-0', colors.iconBg)}>
						<Icon className={colors.title} size={20} />
					</div>
					<div className='min-w-0'>
						<CardTitle className={cn('text-lg', colors.title)}>{title}</CardTitle>
						<CardDescription>{description}</CardDescription>
					</div>
				</div>
				{action ? (
					<div className='flex w-full min-w-0 flex-wrap gap-2 *:min-w-0 *:max-w-full'>{action}</div>
				) : null}
			</CardHeader>
			<CardContent className='px-4 py-4'>{children}</CardContent>
		</Card>
	);
}
